import { gql } from '@apollo/client';

const QUERY_ELEVES_WITH_ORDERS_IN_CLASSE = gql`
  query getOrdersByEleveInClasse {
    findElevesWithOrders {
      users {
        firstname
        lastname
        commandes {
          numerocommande
          totalttc
          methodepaiement
          payment
          fraislivraison
          status
          id
          customerContributedToTheOng
          controlled
          prixTotal
          client {
            prenom
            nom
          }
        }
      }
    }
  }
`;

export default QUERY_ELEVES_WITH_ORDERS_IN_CLASSE;
